const DEPOSIT_INSURENCE_THEMES = {
    BLUE: 'blue',
    MONOCHROME: 'monochrome',
};

export {
    DEPOSIT_INSURENCE_THEMES,
};
